export const MAIN_BLUE = "#3FA7D6";
export const MAIN_GREEN = "#59CD90";
export const MAIN_GRAY = "#909090";
export const MAIN_YELLOW = "#FAC05E";
export const MAIN_RED = "#EA5C57";
export const MAIN_BLACK = "#463D3E";

export const MAIN_BACKGROUND = "#010101";

export const LIGHT_GREEN = "#F0FEED";
export const LIGHT_GRAY = "#EFEFEF";

export const LIGHTEST_GRAY = "#F7F7F7";
export const LIGHTEST_ORANGE = "#FAEDEA";
export const LIGTHEST_GREEN = "#F0FEED";
export const LIGHEST_BLUE = "#E9F4FC";
export const LIGHTEST_YELLOW = "#FDF8E9";
export const LIGHTEST_PINK = "#FDE9FB";
